/**
 * Created by yangxx on 2017/9/11.
 * 测量组件外部定义
 */
'use strict';
define([
    '../base/PureComponent',
    '../utils/CommonUtil',
    '../utils/RenderUtil',
    '../utils/GeometryUtil',
    '../g2'
], function(
    PureComponent,
    CommonUtil,
    RenderUtil,
    GeometryUtil,
    g2
) {
    var fn = function(component, MEASURE_TAG) {
        var COMMANDNAMES = {
            'NoopTool': 'NoopTool'
        };
        component.include({
            _createTools: function() {
                var symbols = this.options.symbols;
                var lineSymbol = RenderUtil.object2Symbol(symbols.line.type, symbols.line.options),
                    polygonSymbol = RenderUtil.object2Symbol(symbols.polygon.type, symbols.polygon.options);
                var hook = {
                    map: this.map,
                    spatialRef: {
                        srid: this.map.spatialReference
                    },
                    tooltipWare: this._toolTipWare
                };
                //折线
                var path = new g2.sfs.Path({
                    spatialReference: this.map.spatialReference
                });
                var polyline = new g2.sfs.Polyline({
                    spatialReference: this.map.spatialReference
                });
                polyline.addGeometry(path);
                this._polylineTemplate = new g2.sfs.Element({
                    geometry: polyline,
                    symbol: lineSymbol
                });
                this._lineTool = new g2.draw.DrawTool({
                    id: "measureLineTool",
                    cursor: 'crosshair',
                    templateElement: this._polylineTemplate.copy(),
                    drawLayer: this._drawLayer
                });
                this._extendLineTool(this._lineTool);
                this._lineTool.onCreate(hook);
                //多边形
                var ring = new g2.sfs.Ring({
                    spatialReference: this.map.spatialReference
                });
                var polygon = new g2.sfs.Polygon({
                    spatialReference: this.map.spatialReference
                });
                polygon.addGeometry(ring);
                this._polygonTemplate = new g2.sfs.Element({
                    geometry: polygon,
                    symbol: polygonSymbol
                });
                this._polygonTool = new g2.draw.DrawTool({
                    id: "measurePolygonTool",
                    cursor: 'crosshair',
                    templateElement: this._polygonTemplate.copy(),
                    drawLayer: this._drawLayer
                });
                this._extendPolygonTool(this._polygonTool);
                this._polygonTool.onCreate(hook);
                //圆
                this._circleTool = new g2.draw.DrawTool({
                    id: "measureCircleTool",
                    cursor: 'crosshair',
                    templateElement: this._polygonTemplate.copy(),
                    drawLayer: this._drawLayer
                });
                this._extendCircleTool(this._circleTool);
                this._circleTool.onCreate(hook);
                //椭圆
                this._ellipseTool = new g2.draw.DrawTool({
                    id: "measureEllipseTool",
                    cursor: 'crosshair',
                    templateElement: this._polygonTemplate.copy(),
                    drawLayer: this._drawLayer
                });
                this._extendEllipseTool(this._ellipseTool);
                this._ellipseTool.onCreate(hook);
                //默认工具
                this._noopTool = new g2.interact.NoopTool({
                    id: COMMANDNAMES.NoopTool,
                    cursor: 'pointer'
                });
                this._noopTool.onCreate(hook);
            },
            _extendLineTool: function(tool) {
                var self = this;
                tool.onMouseUp = function() {
                    onMouseUp.apply(self, arguments);
                }
                tool.onEndDraw = function() {
                        onEndDraw.apply(self, arguments);
                    }
                    //
                function onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    //防止因为鼠标移动过快出现节点偏移的问题
                    var points = this._lineTool.drawElement.geometry.paths[0].points,
                        pts = points.slice(measuringObj.points.length);
                    if ('ontouchend' in document) { //支持触屏事件
                        if (measuringObj.points.length === 0) {
                            pts = pts.slice(0, 1).concat(pts.slice(2))
                        } else if (measuringObj.points.length === 1) {
                            pts = pts.slice(1);
                        }
                    } else {
                        pts = pts.slice(0, pts.length - 1);
                    }
                    for (var k = 0, ll = pts.length; k < ll; k++) {
                        var point = pts[k];
                        //添加节点
                        var nodeEle = this._addNodeEle(measureId, point, this._nodeSymbol);
                        measuringObj.nodes.push(nodeEle);
                        measuringObj.points.push(point);
                        //
                        var html,
                            styleName = this._getStyleName(0),
                            length,
                            layerId = this._measureLayer.id,
                            offset = [10, 0];
                        //起点
                        if (measuringObj.points.length == 1) {
                            html = this.options.lengthTipFn('start');
                        } else {
                            length = this._measurePolyline(measuringObj.points);
                            html = this.options.lengthTipFn('node', length);
                        }
                        var tooltip = new g2.widget.Tooltip({
                            id: CommonUtil.newUUID32(),
                            anchor: point, //提示在地图上停靠位置
                            content: html, //提示内容
                            layerId: layerId, //提示所在图层ID
                            offset: offset, //位置偏移量
                            className: styleName //tooltip样式
                        });
                        measuringObj.tooltips.push(tooltip);
                        this._toolTipWare.add(tooltip);
                    }
                }
                //
                function onEndDraw(ele) {
                    ele = ele || this._drawLayer.elements[0];
                    //
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    //reconstruct
                    if (measuringObj.points.length < 2) {
                        throw (new Error('距离测量至少两个点！'));
                    }
                    ele.geometry = this._constructGeometry('polyline', measuringObj.points);
                    //udpate tooltip
                    //remove last
                    var last = measuringObj.tooltips.splice(measuringObj.tooltips.length - 1, 1)[0];
                    this._toolTipWare.remove(last.id);
                    // add new
                    var layerId = this._measureLayer.id,
                        styleName = this._getStyleName(1),
                        length = this._measurePolyline(measuringObj.points),
                        html = this.options.lengthTipFn('end', length);
                    //caculate anchor
                    var offset = caculateOffset.call(this, measuringObj);
                    var tooltip = new g2.widget.Tooltip({
                        id: CommonUtil.newUUID32(),
                        anchor: last.anchor, //提示在地图上停靠位置
                        content: html, //提示内容
                        layerId: layerId, //提示所在图层ID
                        offset: [10, offset[1]], //位置偏移量
                        className: styleName //tooltip样式
                    });
                    measuringObj.tooltips.push(tooltip);
                    this._toolTipWare.add(tooltip);
                    //add delete marker
                    this._deleteSymbol.offsetX = offset[0];
                    this._deleteSymbol.offsetY = offset[1];
                    var deleteEle = new g2.sfs.Element({
                        geometry: last.anchor,
                        symbol: this._deleteSymbol
                    });
                    deleteEle[MEASURE_TAG] = measureId;
                    this._measureLayer.add(deleteEle);
                    measuringObj.deleteEle = deleteEle;
                    //
                    this._measureLayer.add(ele);
                    //refer
                    measuringObj.element = ele;
                    //save
                    this._measures[measureId] = measuringObj;
                    //reset
                    this._measuringObj = null;
                    //cancel measure
                    this.cancel();
                }

                function caculateOffset(measureObj) {
                    var symbolObj = this.options.symbols.delete.options;
                    var width = symbolObj.width,
                        height = symbolObj.height,
                        offsetX = symbolObj.offsetX,
                        offsetY = symbolObj.offsetY,
                        minOffset = 5,
                        points = measureObj.points;
                    if (isNaN(offsetX) && points.length > 1) {
                        var last = points[points.length - 1],
                            llast = points[points.length - 2];
                        if (last.x >= llast.x) {
                            offsetX = -1 * (minOffset);
                        } else {
                            offsetX = width + minOffset;
                        }
                    }
                    if (isNaN(offsetY)) {
                        offsetY = height / 2;
                    }
                    return [offsetX, offsetY];
                }
            },
            _extendPolygonTool: function(tool) {
                var self = this;
                tool.onMouseUp = function() {
                    onMouseUp.apply(self, arguments);
                }
                tool.onEndDraw = function() {
                    onEndDraw.apply(self, arguments);
                }

                function onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    //防止因为鼠标移动过快出现节点偏移的问题
                    var points = this._polygonTool.drawElement.geometry.shell.points;
                    if (points.length > 2) {
                        point = points[points.length - 3];
                    }
                    //添加节点
                    var nodeEle = this._addNodeEle(measureId, point, this._nodeSymbol);
                    measuringObj.nodes.push(nodeEle);
                    measuringObj.points.push(point);
                }

                function onEndDraw(ele) {
                    ele = ele || this._drawLayer.elements[0];
                    //
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    //reconstruct
                    if (measuringObj.points.length < 3) {
                        throw (new Error('多边形测量至少三个点！'));
                    }
                    ele.geometry = this._constructGeometry('polygon', measuringObj.points);
                    var measureVals = this._measurePolygon(measuringObj.points);
                    var styleName = this._getStyleName(1),
                        layerId = this._measureLayer.id,
                        offset = [0, 0],
                        html = this.options.areaTipFn.apply(window, measureVals);
                    var center = ele.geometry.getBaryCenter(),
                        anchor = new g2.sfs.Point(center);
                    var tooltip = new g2.widget.Tooltip({
                        id: CommonUtil.newUUID32(),
                        anchor: anchor, //提示在地图上停靠位置
                        content: html, //提示内容
                        layerId: layerId, //提示所在图层ID
                        offset: offset, //位置偏移量
                        className: styleName //tooltip样式
                    });
                    measuringObj.tooltips.push(tooltip);
                    this._toolTipWare.add(tooltip);
                    //add delete marker
                    //caculate anchor
                    var offset = this._caculateDeleteMarkerOffset(measuringObj);
                    this._deleteSymbol.offsetX = offset[0];
                    this._deleteSymbol.offsetY = offset[1];
                    var deleteGeom = measuringObj.points[measuringObj.points.length - 1];
                    var deleteEle = new g2.sfs.Element({
                        geometry: deleteGeom,
                        symbol: this._deleteSymbol
                    });
                    deleteEle[MEASURE_TAG] = measureId;
                    this._measureLayer.add(deleteEle);
                    measuringObj.deleteEle = deleteEle;
                    //add link
                    this._addLinkEle(measuringObj, anchor, deleteGeom);
                    //
                    this._measureLayer.add(ele);
                    //refer
                    measuringObj.element = ele;
                    //save
                    this._measures[measureId] = measuringObj;
                    //reset
                    this._measuringObj = null;
                    //cancel measure
                    this.cancel();
                }
            },
            _extendCircleTool: function(tool) {
                var self = this;
                tool.onMouseUp = function() {
                    onMouseUp.apply(self, arguments);
                }
                tool.onMouseMove = function() {
                    onMouseMove.apply(self, arguments);
                }
                tool.onEndDraw = function() {
                    self._onCircleEllipseEndDraw.apply(self, arguments);
                }

                function onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    if (measuringObj.points.length == 0) {
                        measuringObj.points.push(point);
                    } else { //单击也能结束
                        showCircle.call(this, measuringObj, point);
                        this._onCircleEllipseEndDraw.call(this);
                    }
                }

                function onMouseMove(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    showCircle.call(this, measuringObj, point);
                }

                function showCircle(measuringObj, point) {
                    if (measuringObj.points.length > 0) {
                        measuringObj.points = measuringObj.points.splice(0, 1);
                        measuringObj.points.push(point);
                        //
                        var points = measuringObj.points,
                            center = points[0],
                            destPoint = points[1],
                            centerPixel = this.map.getPixelFromCoordinate([center.x, center.y]),
                            destPixel = this.map.getPixelFromCoordinate([destPoint.x, destPoint.y]),
                            radius = Math.sqrt(Math.pow(centerPixel[0] - destPixel[0], 2) +
                                Math.pow(centerPixel[1] - destPixel[1], 2));
                        if (parseFloat(radius).toFixed(6) == 0) {
                            return;
                        }
                        var circlePoints = GeometryUtil.getCirclePonits({
                            center: centerPixel,
                            radius: radius,
                            count: 128,
                            spatialReference: 3857
                        });
                        var ring = new g2.sfs.Ring();
                        for (var i = 0, len = circlePoints.length; i < len; i++) {
                            var circlePoint = circlePoints[i],
                                pt = this.map.getCoordinateFromPixel(circlePoint);
                            ring.addPoint(new g2.sfs.Point({
                                x: pt[0],
                                y: pt[1]
                            }));
                        }
                        var element = this._drawLayer.elements[0],
                            geometry = element.geometry;
                        geometry.removeAllGeometry();
                        geometry.addGeometry(ring);
                        this._drawLayer.update(element);
                    }
                }
            },
            _extendEllipseTool: function(tool) {
                var self = this;
                tool.onMouseUp = function() {
                    onMouseUp.apply(self, arguments);
                }
                tool.onMouseMove = function() {
                    onMouseMove.apply(self, arguments);
                }
                tool.onEndDraw = function() {
                    self._onCircleEllipseEndDraw.apply(self, arguments);
                }

                function onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    if (measuringObj.points.length == 0) {
                        measuringObj.points.push(point);
                        //plotelement
                        this._ellipseElement = constructPlotEle.call(this, {});
                        this._ellipseElement.plot.addControlPoint(point);
                    } else {
                        showEllipse.call(this, measuringObj, point);
                        this._onCircleEllipseEndDraw.call(this);
                    }
                }

                function onMouseMove(button, shift, screenx, screeny, mapx, mapy, handled) {
                    var measureId = this._measuringTool[MEASURE_TAG],
                        measuringObj = this._getMeasuring(measureId);
                    var point = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    });
                    showEllipse.call(this, measuringObj, point);
                }
                //构建标绘元素
                function constructPlotEle(opts) {
                    var algorithm = new g2.plot.EllipseAlgorithm({});
                    var attributes = new g2.sfs.AttributeSet();
                    var plotEle = new g2.sfs.PlotElement({
                        id: CommonUtil.newUUID32(),
                        kind: 'ellipseTemplate',
                        algorithm: algorithm,
                        attributeSet: attributes
                    });
                    var ele = new g2.sfs.Element({
                        geometry: new g2.sfs.Polygon(),
                        attributeSet: attributes
                    });
                    plotEle.add(ele);
                    //
                    plotEle.reset();
                    return plotEle;
                }

                function showEllipse(measuringObj, point) {
                    if (measuringObj.points.length > 0) {
                        measuringObj.points = measuringObj.points.splice(0, 1);
                        measuringObj.points.push(point);
                        //
                        var plot = this._ellipseElement.plot,
                            algorithm = this._ellipseElement.algorithm;
                        var ellipse = algorithm.createGeometries(plot, point)[0];
                        var element = this._drawLayer.elements[0];
                        element.geometry = ellipse;
                        this._drawLayer.update(element);
                    }
                }
            },
            _constructGeometry: function(type, points) {
                var obj = {
                    'polyline': function(points) {
                        var path = new g2.sfs.Path();
                        for (var i = 0; i < points.length; i++) {
                            path.addPoint(points[i]);
                        }
                        var polyline = new g2.sfs.Polyline();
                        polyline.addGeometry(path);
                        return polyline;
                    },
                    'polygon': function(points) {
                        var ring = new g2.sfs.Ring();
                        for (var i = 0; i < points.length; i++) {
                            ring.addPoint(points[i]);
                        }
                        var polygon = new g2.sfs.Polygon();
                        polygon.addGeometry(ring);
                        return polygon;
                    }
                };
                return obj[type](points);
            },
            //圆椭圆绘制完成
            _onCircleEllipseEndDraw: function(ele) {
                ele = ele || this._drawLayer.elements[0];
                var measureId = this._measuringTool[MEASURE_TAG],
                    measuringObj = this._getMeasuring(measureId),
                    ring = ele.geometry.shell;
                var measureVals = this._measurePolygon(ring.points);
                var styleName = this._getStyleName(1),
                    layerId = this._measureLayer.id,
                    offset = [0, 0],
                    html = this.options.areaTipFn.apply(window, measureVals);
                var center = ele.geometry.getBaryCenter(),
                    anchor = new g2.sfs.Point(center);
                var tooltip = new g2.widget.Tooltip({
                    id: CommonUtil.newUUID32(),
                    anchor: anchor, //提示在地图上停靠位置
                    content: html, //提示内容
                    layerId: layerId, //提示所在图层ID
                    offset: offset, //位置偏移量
                    className: styleName //tooltip样式
                });
                measuringObj.tooltips.push(tooltip);
                this._toolTipWare.add(tooltip);
                //add delete marker
                //caculate anchor
                var offset = this._caculateDeleteMarkerOffset(measuringObj, true);
                this._deleteSymbol.offsetX = offset[0];
                this._deleteSymbol.offsetY = offset[1];
                //获取圆上右上角点
                var deleteGeom = ring.points[parseInt((ring.points.length - 1) * 7 / 8)];
                var deleteEle = new g2.sfs.Element({
                    geometry: deleteGeom,
                    symbol: this._deleteSymbol
                });
                deleteEle[MEASURE_TAG] = measureId;
                this._measureLayer.add(deleteEle);
                measuringObj.deleteEle = deleteEle;
                //add link
                this._addLinkEle(measuringObj, anchor, deleteGeom);
                //
                this._measureLayer.add(ele);
                //refer
                measuringObj.element = ele;
                //save
                this._measures[measureId] = measuringObj;
                //reset
                this._measuringObj = null;
                //cancel measure
                this.cancel();
            },
            _caculateDeleteMarkerOffset: function(measureObj, toRight) {
                var symbolObj = this.options.symbols.delete.options;
                var width = symbolObj.width,
                    height = symbolObj.height,
                    offsetX = symbolObj.offsetX,
                    offsetY = symbolObj.offsetY,
                    minOffset = 5,
                    points = measureObj.points;
                if (isNaN(offsetX) && points.length > 1) {
                    var last = points[points.length - 1],
                        llast = points[points.length - 2];
                    if (toRight === true || last.x >= llast.x) {
                        offsetX = -1 * (minOffset);
                    } else {
                        offsetX = width + minOffset;
                    }
                }
                if (isNaN(offsetY)) {
                    offsetY = height / 2;
                }
                return [offsetX, offsetY];
            },
            //添加节点元素
            _addNodeEle: function(measureId, point, symbol) {
                var nodeEle = new g2.sfs.Element({
                    geometry: point,
                    symbol: symbol
                });
                this._measureLayer.add(nodeEle);
                return nodeEle;
            },
            //添加连线
            _addLinkEle: function(measureObj, point1, point2) {
                if (this.options.showTipLink === true) {
                    var symbols = this.options.symbols;
                    var path = new g2.sfs.Path();
                    path.addPoint(point1);
                    path.addPoint(point2);
                    var polyline = new g2.sfs.Polyline();
                    polyline.addGeometry(path);
                    //
                    var symbol = jQuery.extend(true, {}, symbols.line);
                    if (symbol.type == 'SimpleFillSymbol') {
                        var obj = {
                            type: 'SimpleLineSymbol',
                            options: {
                                color: symbol.options.borderColor,
                            }
                        };
                        symbol = obj;
                    }
                    symbol.options.style = 3; //虚线
                    symbol.options.width = 2;
                    symbol.options.color.a = (symbol.options.color.a || symbol.options.color.alpha || 0) * 0.7;
                    var element = RenderUtil.geoinfoToElement(polyline, symbol);
                    this._measureLayer.add(element);
                    //
                    measureObj.linkEle = element;
                }
            },
            _getStyleName: function(index) {
                var styleName;
                if (CommonUtil.isArray(this.options.styleName)) {
                    styleName = this.options.styleName[index];
                } else {
                    styleName = this.options.styleName;
                }
                return styleName;
            },
            /***
             * 获取当前测量
             * @private
             */
            _getMeasuring: function(id) {
                if (!this._measuringObj) {
                    this._measuringObj = {
                        //元素
                        element: null,
                        //
                        points: [],
                        //提示
                        tooltips: [],
                        //节点元素
                        nodes: [],
                        //删除图标元素
                        deleteEle: null,
                        //连线元素
                        linkEle: null
                    }
                }
                this._measuringObj.id = id;
                return this._measuringObj;
            },
            _measurePolyline: function(pointArr) {
                var path = new g2.sfs.Path({
                    spatialReference: this.map.spatialReference
                });
                for (var i = 0, len = pointArr.length; i < len; i++) {
                    path.addPoint(pointArr[i]);
                }
                var polyline = new g2.sfs.Polyline({
                    spatialReference: this.map.spatialReference
                });
                polyline.addGeometry(path);
                return GeometryUtil.measureLength(polyline);
            },
            _measurePolygon: function(pointArr) {
                var ring = new g2.sfs.Ring({
                    spatialReference: this.map.spatialReference
                });
                for (var i = 0, len = pointArr.length; i < len; i++) {
                    ring.addPoint(pointArr[i]);
                }
                //闭合
                ring.addPoint(pointArr[0]);
                var polygon = new g2.sfs.Polygon({
                    spatialReference: this.map.spatialReference
                });
                polygon.addGeometry(ring);
                var len = GeometryUtil.measureLength(polygon),
                    area = GeometryUtil.measureArea(polygon);
                return [len, area];
            },
        });
    }
    return {
        extend: fn
    }
});